import { AdobeConstants, FilterSLOA } from "./AdobeConstants";

//Initial implementation of AdobeHelpers, will likely need updates as we do the actual Adobe Tagging
export class AdobeHelpers {
    static trackPage(name: string, data?: any): void {
      if (!(window as any)['tms'] || !(window as any)['tms'].trackPage) {
        return;
      }else {
        (window as any)['tms'].trackPage(name, data);
      }
    }

    static trackFilteredBy(id: string, filteredBy: string, preTag?: string, postTag?: string): void {
      var flow = preTag ? preTag : '';
      switch (filteredBy) {
          case AdobeConstants.MONEYLINK:
          case FilterSLOA.moneylink:
              flow += AdobeConstants._MONEYLINK;
              break;
          case AdobeConstants.CHECK:
          case FilterSLOA.check:
              flow += AdobeConstants._CHECK;
              break;
          case AdobeConstants.INTERNAL_TRANSFER:
          case FilterSLOA.journal:
              flow += AdobeConstants._INTERNAL_TRANSFER;
              break;
          case AdobeConstants.WIRE:
          case FilterSLOA.wire:
              flow += AdobeConstants._WIRE;
              break;
          default:
              flow += AdobeConstants._ALL;
              break;
      }
      flow += postTag ? postTag : '';
      this.trackClick(id, flow);
    }

    // This method adds an event listener to the element with provided ID.
    // When the element is clicked, the GUTtrack method is called.
    // Once the event occurs, the listener is removed so clicks are only tracked once
    // returns true if element is found and false if not found
    static trackClick(id: string, description: string, type: string = 'click'): boolean {
      const element = document.getElementById(id);
      if (element) {
          if (element.getAttribute('adobeTracking') === 'true')
          {
            return true;
          }
          element.addEventListener(
              type,
              function() {
                  if ((window as any)['GUTtrack'] && typeof (window as any)['GUTtrack'] == 'function') {
                    (window as any)['GUTtrack'](description);
                  }
              },
              { once: true }
          );
          element.setAttribute('adobeTracking', 'true');
          return true;
      }
      return false;
    }

    //This method will immediatly fire a GUT Track call without validating previous fire events.
    //WARNING: This should only be used in circumstances where we are sure a user can only click a button once.
    //The intention is to give us the ability to ensure a tag can be fired in certain race conditions involding passive tracking and page loads.
    static fireClick(description: string): void {
      if ((window as any)['GUTtrack'] && typeof (window as any)['GUTtrack'] == 'function') {
        (window as any)['GUTtrack'](description);
      }
    }

    static TrackElement(id: string, description: string, shouldFireOnce: boolean): void {
      if (!(window as any)['GUTtrack']) {
          return;
      }
      const element = document.getElementById(id);
      if (element && shouldFireOnce) {
        (window as any)['GUTtrack'](`${description}|fireonce`);
      }
      if (element && !shouldFireOnce) {
        (window as any)['GUTtrack'](`${description}`);
      }
    }

}
